import qs from "qs";
import axios from "axios";

// Helper: Attach token to all requests
const setTokenHeader = () => {
    const token = localStorage.getItem("adminToken");
    if (token) {
        axios.defaults.headers.common["Authorization"] = token;
    }
};

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            // Clear any stored auth tokens
            localStorage.removeItem("adminToken");
            // Redirect to login page
            window.location.href = "/login"; // adjust if your login route is different
        }

        return Promise.reject(error);
    }
);

// Generic GET
// export const axiosGet = async (baseURL, params = {}) => {
//     try {
//         setTokenHeader();
//         const response = await axios.get(baseURL, {
//             params,
//             headers: {
//                 "Cache-Control": "no-cache",
//                 Pragma: "no-cache",
//                 Expires: "0",
//             },
//         });
//         return response.data;
//     } catch (error) {
//         console.error(`GET ${baseURL} failed:`, error);
//         throw error;
//     }
// };

export const axiosGet = async (baseURL, params = {}) => {
    try {
        setTokenHeader();
        const response = await axios.get(baseURL, {
            params,
            paramsSerializer: (params) =>
                qs.stringify(params, { arrayFormat: "indices", encode: false }),
            headers: {
                "Cache-Control": "no-cache",
                Pragma: "no-cache",
                Expires: "0",
            },
        });
        return response.data;
    } catch (error) {
        console.error(`GET ${baseURL} failed:`, error);
        throw error;
    }
};

export const axiosGetBlob = async (baseURL, onDownloadProgress = null, params = {}) => {
    try {
        setTokenHeader();
        const response = await axios.get(baseURL, {
            params,
            headers: {
                "Cache-Control": "no-cache",
                Pragma: "no-cache",
                Expires: "0",
            },
            responseType: 'blob',
            onDownloadProgress: (progressEvent) => {
                const { loaded, total } = progressEvent;
                // console.log("Progress:", loaded, total, total ? (loaded / total) * 100 : "Unknown total");
            },
        });
        return response;
    } catch (error) {
        console.error(`GET ${baseURL} failed:`, error);
        throw error;
    }
};

// Generic POST
export const axiosPost = async (baseURL, body = {}) => {
    try {
        setTokenHeader();
        const response = await axios.post(baseURL, body);
        return response.data;
    } catch (error) {
        console.error(`POST ${baseURL} failed:`, error);
        throw error;
    }
};
export const axiosPostWithFile = async (baseURL, body = {}) => {
    try {
        setTokenHeader();
        const response = await axios.post(baseURL, body, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (error) {
        console.error(`POST ${baseURL} failed:`, error);
        throw error;
    }
};
